import { observable, action, makeObservable } from 'mobx';

export class RangeEnforcement implements IRangeEnforcement {
    @observable useAutoCalculateLumpSum: boolean;
    @observable allowOverrideLumpSum: boolean;
    @observable autoCalculatePercentage: number;

    constructor(dto: IRangeEnforcement) {
        makeObservable(this);
        this.useAutoCalculateLumpSum = dto?.useAutoCalculateLumpSum;
        this.allowOverrideLumpSum = dto?.allowOverrideLumpSum;
        this.autoCalculatePercentage = dto?.autoCalculatePercentage;
    }

    @action
    setAutoCalculatePercentage(autoCalculatePercentage: number): void {
        this.autoCalculatePercentage = autoCalculatePercentage;
    }

    @action
    setUseAutoCalculateLumpSum(useAutoCalculateLumpSum: boolean): void {
        this.useAutoCalculateLumpSum = useAutoCalculateLumpSum;
    }

    @action
    setAllowOverrideLumpSum(allowOverrideLumpSum: boolean): void {
        this.allowOverrideLumpSum = allowOverrideLumpSum;
    }
}